var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuClasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kidex_classes",
    "data-name": "kidex classes",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53297",
    "data-name": "Group 53297",
    transform: "translate(0.352 0.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53273",
    "data-name": "Group 53273",
    transform: "translate(8.584 17.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24763",
    "data-name": "Path 24763",
    d: "M196.749,377.978v-5.04h-1.759V375.2a1.306,1.306,0,1,1-2.612,0v-2.261H190.62v5.04Z",
    transform: "translate(-190.62 -372.938)",
    fill: "#eef4f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53272",
    "data-name": "Group 53272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24764",
    "data-name": "Path 24764",
    d: "M283.862,372.938h1.759v2.226h-1.759Z",
    transform: "translate(-279.491 -372.938)",
    fill: "#cbe5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24765",
    "data-name": "Path 24765",
    d: "M190.62,372.938h1.759v2.226H190.62Z",
    transform: "translate(-190.62 -372.938)",
    fill: "#cbe5e7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53295",
    "data-name": "Group 53295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53274",
    "data-name": "Group 53274",
    transform: "translate(0 2.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24766",
    "data-name": "Path 24766",
    d: "M30.8,64.433v14.35a.559.559,0,0,1-.559.559H8.061a.559.559,0,0,1-.559-.559V64.433a.559.559,0,0,1,.559-.559H30.24A.559.559,0,0,1,30.8,64.433Z",
    transform: "translate(-7.502 -63.874)",
    fill: "#557983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24767",
    "data-name": "Path 24767",
    d: "M448.917,64.432V78.783a.559.559,0,0,1-.559.559h-2.174a.559.559,0,0,0,.559-.559V64.432a.559.559,0,0,0-.559-.559h2.174A.559.559,0,0,1,448.917,64.432Z",
    transform: "translate(-425.62 -63.873)",
    fill: "#47666b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53276",
    "data-name": "Group 53276",
    transform: "translate(1.678 4.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24768",
    "data-name": "Path 24768",
    d: "M63.231,101.121V112.1a.521.521,0,0,1-.521.521H43.81a.521.521,0,0,1-.521-.521V101.121a.521.521,0,0,1,.521-.521h18.9a.521.521,0,0,1,.521.521Z",
    transform: "translate(-43.289 -100.6)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53275",
    "data-name": "Group 53275",
    transform: "translate(7.103 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24769",
    "data-name": "Path 24769",
    d: "M200.555,101.331a2.868,2.868,0,1,1-5.642-.731h5.547A2.876,2.876,0,0,1,200.555,101.331Z",
    transform: "translate(-194.819 -100.6)",
    fill: "#8dcafc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24770",
    "data-name": "Path 24770",
    d: "M425.831,101.127v10.984a.521.521,0,0,1-.521.521h-1.589a.521.521,0,0,0,.521-.521V101.127a.521.521,0,0,0-.521-.521h1.589A.521.521,0,0,1,425.831,101.127Z",
    transform: "translate(-412.992 -100.606)",
    fill: "#8dcafc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53280",
    "data-name": "Group 53280",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53277",
    "data-name": "Group 53277",
    transform: "translate(0 1.048)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_789",
    "data-name": "Ellipse 789",
    cx: 2.868,
    cy: 2.868,
    r: 2.868,
    transform: "translate(0 0)",
    fill: "#eef4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24771",
    "data-name": "Path 24771",
    d: "M246.266,32.723a2.87,2.87,0,0,1-3.487,2.8,2.869,2.869,0,0,0,0-5.6,2.9,2.9,0,0,1,.62-.067A2.868,2.868,0,0,1,246.266,32.723Z",
    transform: "translate(-240.531 -29.855)",
    fill: "#cbe5e7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53278",
    "data-name": "Group 53278",
    transform: "translate(1.834 2.883)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_790",
    "data-name": "Ellipse 790",
    cx: 1.033,
    cy: 1.033,
    r: 1.033,
    fill: "#64b9fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53279",
    "data-name": "Group 53279",
    transform: "translate(1.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24772",
    "data-name": "Path 24772",
    d: "M224.267,9.026h-2.735a.26.26,0,0,1-.26-.26V7.76a.26.26,0,0,1,.26-.26h2.735a.26.26,0,0,1,.26.26V8.766A.26.26,0,0,1,224.267,9.026Z",
    transform: "translate(-221.271 -7.5)",
    fill: "#557983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24773",
    "data-name": "Path 24773",
    d: "M260.968,7.76V8.766a.26.26,0,0,1-.26.26h-1.2a.26.26,0,0,0,.26-.26V7.76a.26.26,0,0,0-.26-.26h1.2A.26.26,0,0,1,260.968,7.76Z",
    transform: "translate(-257.712 -7.5)",
    fill: "#47666b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53287",
    "data-name": "Group 53287",
    transform: "translate(4.554 6.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53283",
    "data-name": "Group 53283",
    transform: "translate(10.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24774",
    "data-name": "Path 24774",
    d: "M328.559,183.972a.78.78,0,0,0-.12-.421,2.158,2.158,0,0,0-3.635,0,.78.78,0,0,0-.12.421v.741h3.875Z",
    transform: "translate(-324.684 -180.785)",
    fill: "#27e19d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24775",
    "data-name": "Path 24775",
    d: "M356.94,183.976v.742h-1.083v-.742a.781.781,0,0,0-.12-.421,2.161,2.161,0,0,0-1.276-.926,2.162,2.162,0,0,1,2.359.926A.781.781,0,0,1,356.94,183.976Z",
    transform: "translate(-353.065 -180.788)",
    fill: "#26d192"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53282",
    "data-name": "Group 53282",
    transform: "translate(1.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53281",
    "data-name": "Group 53281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24776",
    "data-name": "Path 24776",
    d: "M346.492,145.683v.35a.93.93,0,0,0,.933.933.915.915,0,0,0,.9-.915v-.368a.915.915,0,0,0-1.83,0Z",
    transform: "translate(-346.492 -144.768)",
    fill: "#ffcec0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53286",
    "data-name": "Group 53286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24777",
    "data-name": "Path 24777",
    d: "M108.529,183.972a.78.78,0,0,0-.12-.421,2.158,2.158,0,0,0-3.635,0,.78.78,0,0,0-.12.421v.741h3.875Z",
    transform: "translate(-104.654 -180.785)",
    fill: "#fb3a82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24778",
    "data-name": "Path 24778",
    d: "M136.91,183.976v.742h-1.083v-.742a.781.781,0,0,0-.12-.421,2.16,2.16,0,0,0-1.276-.926,2.162,2.162,0,0,1,2.359.926A.781.781,0,0,1,136.91,183.976Z",
    transform: "translate(-133.035 -180.788)",
    fill: "#fb1466"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53285",
    "data-name": "Group 53285",
    transform: "translate(1.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53284",
    "data-name": "Group 53284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24779",
    "data-name": "Path 24779",
    d: "M126.462,145.683v.35a.93.93,0,0,0,.933.933.915.915,0,0,0,.9-.915v-.368a.915.915,0,0,0-1.83,0Z",
    transform: "translate(-126.462 -144.768)",
    fill: "#ffcec0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53294",
    "data-name": "Group 53294",
    transform: "translate(4.554 12.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53290",
    "data-name": "Group 53290",
    transform: "translate(10.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24780",
    "data-name": "Path 24780",
    d: "M328.559,312.536a.78.78,0,0,0-.12-.421,2.158,2.158,0,0,0-3.635,0,.78.78,0,0,0-.12.421v.741h3.875Z",
    transform: "translate(-324.684 -309.349)",
    fill: "#fca62f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24781",
    "data-name": "Path 24781",
    d: "M356.94,312.536v.741h-1.083v-.741a.78.78,0,0,0-.12-.421,2.159,2.159,0,0,0-1.276-.927,2.161,2.161,0,0,1,2.359.927A.781.781,0,0,1,356.94,312.536Z",
    transform: "translate(-353.065 -309.349)",
    fill: "#f98824"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53289",
    "data-name": "Group 53289",
    transform: "translate(1.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53288",
    "data-name": "Group 53288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24782",
    "data-name": "Path 24782",
    d: "M346.492,274.248v.35a.93.93,0,0,0,.933.933.915.915,0,0,0,.9-.915v-.368a.915.915,0,0,0-1.83,0Z",
    transform: "translate(-346.492 -273.333)",
    fill: "#ffcec0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53293",
    "data-name": "Group 53293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24783",
    "data-name": "Path 24783",
    d: "M108.529,312.536a.78.78,0,0,0-.12-.421,2.158,2.158,0,0,0-3.635,0,.78.78,0,0,0-.12.421v.741h3.875Z",
    transform: "translate(-104.654 -309.349)",
    fill: "#fddd45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24784",
    "data-name": "Path 24784",
    d: "M136.91,312.536v.741h-1.083v-.741a.78.78,0,0,0-.12-.421,2.159,2.159,0,0,0-1.276-.927,2.161,2.161,0,0,1,2.359.927A.78.78,0,0,1,136.91,312.536Z",
    transform: "translate(-133.035 -309.349)",
    fill: "#f8c52d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53292",
    "data-name": "Group 53292",
    transform: "translate(1.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53291",
    "data-name": "Group 53291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24785",
    "data-name": "Path 24785",
    d: "M126.462,274.248v.35a.93.93,0,0,0,.933.933.915.915,0,0,0,.9-.915v-.368a.915.915,0,0,0-1.83,0Z",
    transform: "translate(-126.462 -273.333)",
    fill: "#ffcec0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53296",
    "data-name": "Group 53296",
    transform: "translate(6.774 21.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24786",
    "data-name": "Path 24786",
    d: "M161.24,476.392h-8.709a.52.52,0,0,1-.52-.52v-.342a.52.52,0,0,1,.52-.52h8.709a.52.52,0,0,1,.52.52v.342A.52.52,0,0,1,161.24,476.392Z",
    transform: "translate(-152.011 -475.01)",
    fill: "#557983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24787",
    "data-name": "Path 24787",
    d: "M321.822,475.527v.342a.52.52,0,0,1-.52.52h-1.357a.52.52,0,0,0,.52-.52v-.342a.52.52,0,0,0-.52-.52H321.3A.52.52,0,0,1,321.822,475.527Z",
    transform: "translate(-312.073 -475.007)",
    fill: "#47666b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_53298",
    "data-name": "Group 53298",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24788",
    "data-name": "Path 24788",
    d: "M23.648,13.3A.352.352,0,0,0,24,12.945V3.553a.912.912,0,0,0-.911-.911h-8.31a3.222,3.222,0,0,0-.809-.921.612.612,0,0,0,.01-.1V.612A.613.613,0,0,0,13.368,0H10.632a.613.613,0,0,0-.612.612V1.617a.614.614,0,0,0,.01.1,3.219,3.219,0,0,0-.81.921H.911A.912.912,0,0,0,0,3.553V17.9a.912.912,0,0,0,.911.911H8.584v3.1H7.646a.873.873,0,0,0-.872.872v.342A.873.873,0,0,0,7.646,24h8.709a.873.873,0,0,0,.872-.872v-.342a.873.873,0,0,0-.872-.872h-.938v-3.1h7.673A.912.912,0,0,0,24,17.9V14.68a.352.352,0,0,0-.7,0V17.9a.208.208,0,0,1-.208.208H.911A.208.208,0,0,1,.7,17.9V3.553a.208.208,0,0,1,.208-.208h8a3.225,3.225,0,0,0-.135.922q0,.048,0,.1H2.549a.873.873,0,0,0-.872.872V16.22a.873.873,0,0,0,.872.872H5.917a.352.352,0,1,0,0-.7h-.66V16a.427.427,0,0,1,.064-.231,1.823,1.823,0,0,1,.762-.666,1.241,1.241,0,0,0,.76.26h.024a1.256,1.256,0,0,0,.737-.258,1.826,1.826,0,0,1,.76.664A.427.427,0,0,1,8.429,16v.39H7.652a.352.352,0,1,0,0,.7h13.8a.873.873,0,0,0,.872-.872V5.236a.873.873,0,0,0-.872-.872H15.217c0-.032,0-.064,0-.1a3.221,3.221,0,0,0-.135-.922h8a.208.208,0,0,1,.208.208v9.391a.352.352,0,0,0,.352.352Zm-7.294,9.322a.169.169,0,0,1,.169.169v.342a.169.169,0,0,1-.169.169H7.646a.169.169,0,0,1-.169-.169v-.342a.169.169,0,0,1,.169-.169Zm-5.309-3.8h1.909v.929a.954.954,0,1,1-1.909,0v-.929Zm-1.759,0h1.056v.929a1.658,1.658,0,1,0,3.315,0v-.929h1.056v3.1H9.287ZM13.463,2.221a2.514,2.514,0,0,1,1.028,1.695H13.34a1.39,1.39,0,0,0-.988-.988v-.7h1.016A.614.614,0,0,0,13.463,2.221Zm-.781,2.046A.682.682,0,1,1,12,3.586.682.682,0,0,1,12.682,4.267ZM10.724.7h2.553v.823H10.724ZM2.549,5.067H8.882a3.207,3.207,0,0,0,.272.7.352.352,0,1,0,.621-.329,2.486,2.486,0,0,1-.291-1.175,2.512,2.512,0,0,1,1.054-2.046.614.614,0,0,0,.095.008h1.016v.7A1.385,1.385,0,1,0,13.34,4.619h1.152A2.52,2.52,0,0,1,12,6.784a2.489,2.489,0,0,1-1.139-.273.352.352,0,1,0-.319.627,3.181,3.181,0,0,0,1.106.33v2.9H9.132V9.973a1.129,1.129,0,0,0-.175-.611A2.5,2.5,0,0,0,8.032,8.5a1.249,1.249,0,0,0,.078-.435V7.7a1.267,1.267,0,1,0-2.533,0v.35a1.286,1.286,0,0,0,.083.451,2.533,2.533,0,0,0-.93.86,1.129,1.129,0,0,0-.175.611v.391H2.381V5.236a.169.169,0,0,1,.169-.169ZM6.843,9.336h.024a1.256,1.256,0,0,0,.737-.258,1.826,1.826,0,0,1,.76.664.427.427,0,0,1,.064.231v.39H5.257v-.39a.428.428,0,0,1,.064-.231,1.824,1.824,0,0,1,.762-.666,1.241,1.241,0,0,0,.76.26ZM6.279,8.051V7.7a.564.564,0,1,1,1.127,0v.368a.566.566,0,0,1-.552.563.55.55,0,0,1-.4-.161.593.593,0,0,1-.178-.42ZM7.407,14.1a.566.566,0,0,1-.552.563.55.55,0,0,1-.4-.161.593.593,0,0,1-.178-.42v-.35a.564.564,0,1,1,1.127,0V14.1Zm1.55,1.293a2.5,2.5,0,0,0-.925-.858A1.249,1.249,0,0,0,8.11,14.1v-.368a1.267,1.267,0,1,0-2.533,0v.35a1.286,1.286,0,0,0,.083.452,2.531,2.531,0,0,0-.93.86A1.129,1.129,0,0,0,4.554,16v.39h-2a.169.169,0,0,1-.169-.169V11.067h9.268v5.322H9.132V16a1.128,1.128,0,0,0-.175-.611Zm6.614,1V16a.428.428,0,0,1,.064-.231A1.826,1.826,0,0,1,16.4,15.1a1.241,1.241,0,0,0,.76.259h.024a1.256,1.256,0,0,0,.738-.258,1.823,1.823,0,0,1,.759.664.427.427,0,0,1,.064.231v.39Zm1.022-2.312v-.35a.564.564,0,1,1,1.127,0V14.1a.566.566,0,0,1-.552.563.55.55,0,0,1-.4-.161.593.593,0,0,1-.178-.42Zm4.857,2.312h-2V16a1.129,1.129,0,0,0-.175-.611,2.532,2.532,0,0,0-.926-.857,1.249,1.249,0,0,0,.078-.436v-.368a1.267,1.267,0,1,0-2.533,0v.35a1.287,1.287,0,0,0,.083.451,2.537,2.537,0,0,0-.93.86,1.129,1.129,0,0,0-.175.611v.39H12.352V11.067h9.268V16.22a.169.169,0,0,1-.169.169ZM17.157,9.336h.024a1.256,1.256,0,0,0,.737-.258,1.826,1.826,0,0,1,.76.664.427.427,0,0,1,.064.231v.39H15.571v-.39a.428.428,0,0,1,.064-.231,1.824,1.824,0,0,1,.762-.666,1.241,1.241,0,0,0,.76.26Zm-.564-1.285V7.7a.564.564,0,1,1,1.127,0v.368a.566.566,0,0,1-.552.563.552.552,0,0,1-.4-.161.593.593,0,0,1-.178-.42ZM21.45,5.067a.169.169,0,0,1,.169.169v5.128H19.446V9.973a1.129,1.129,0,0,0-.175-.611,2.5,2.5,0,0,0-.925-.858,1.249,1.249,0,0,0,.078-.435V7.7a1.267,1.267,0,1,0-2.533,0v.35a1.286,1.286,0,0,0,.083.451,2.533,2.533,0,0,0-.93.86,1.129,1.129,0,0,0-.175.611v.391H12.352v-2.9a3.227,3.227,0,0,0,2.766-2.4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24789",
    "data-name": "Path 24789",
    d: "M284.985,251.542h-.523a.352.352,0,0,0,0,.7h.523a.352.352,0,0,0,0-.7Z",
    transform: "translate(-270.793 -239.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24790",
    "data-name": "Path 24790",
    d: "M69.341,251.542h-.523a.352.352,0,0,0,0,.7h.523a.352.352,0,0,0,0-.7Z",
    transform: "translate(-65.258 -239.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24791",
    "data-name": "Path 24791",
    d: "M68.819,123.978h.523a.352.352,0,0,0,0-.7h-.523a.352.352,0,0,0,0,.7Z",
    transform: "translate(-65.258 -117.496)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClasses);
export default __webpack_public_path__ + "static/media/menu-classes.814a251f4017482db4e826772bc6532f.svg";
export { ForwardRef as ReactComponent };